import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-background-200 bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-base" />
              </span>
              <span className="text-base font-bold text-foreground-950">{t('brand')}</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t('footer.navTitle')}</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a href="#categories" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {t('footer.categories')}
                </a>
              </li>
              <li>
                <a href="#guides" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {t('footer.guides')}
                </a>
              </li>
              <li>
                <a href="#reviews" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {t('footer.reviews')}
                </a>
              </li>
              <li>
                <a href="#safety" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {t('footer.safety')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t('footer.resourcesTitle')}</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/article/what-is-usfans-spreadsheet" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {t('whatis.title')}
                </Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {t('common.mainSite')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">
            {t('footer.disclaimer')}
          </p>
          <p className="mt-4 text-xs text-foreground-500">
            © {new Date().getFullYear()} {t('brand')}. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}